import { Formik } from 'formik';
import { initNewLeadStruct } from './helpers/initNewLeadStruct';
import NewLeadForm from './NewLeadForm';
import { LEAD_NAME_MAX_LENGTH } from '@econtractor/types';
import * as apiLead from 'api/apiLeads';
import { useToast } from 'context/ToastContext';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface NewLeadFormikProps {
    setShow: (show: boolean) => void;
    fetchLeads: (force?: boolean) => Promise<void | null>;
}

const NewLeadFormik = ({ setShow, fetchLeads }: NewLeadFormikProps) => {
    const { t } = useTranslation(['Leads', 'common']);
    const { showToast } = useToast();
    const [isValidPhone, setIsValidPhone] = useState(false);

    return (
        <Formik
            initialValues={initNewLeadStruct}
            onSubmit={async (values) => {
                const leadName = String(values.leadName || '').trim().slice(0, LEAD_NAME_MAX_LENGTH);
                const resCreate = await apiLead.createLead({ ...values, leadName });
                if (resCreate) {
                    await fetchLeads(true);
                    setShow(false);
                    showToast(t('newLead.messLeadCreated'), 'success');
                } else showToast(t('common:messError'), 'danger');
            }}
        >
            {({ handleSubmit, isSubmitting, setFieldValue, values }) => (
                <NewLeadForm
                    isValidPhone={isValidPhone}
                    setIsValidPhone={setIsValidPhone}
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    setFieldValue={setFieldValue}
                    values={values}
                />
            )}
        </Formik>
    );
};

export default NewLeadFormik;
